module.exports = "/images/Product and Service Sales Funnels 1.svg?5636f8567e8351df3e85f3d270a6a041";